import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { Search, ChevronRight } from "lucide-react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { PageHeader, Loader, EmptyState } from "@/components/common/Loader";
import { CenterStatusBadge } from "@/components/common/Badges";
import { TextInput } from "@/components/common/Forms";
import { useFetch } from "@/lib/api";
import { fmtDate } from "@/lib/format";

const TABS = [["pending", "In attesa"], ["approved", "Attivi"], ["suspended", "Sospesi"], ["rejected", "Non approvati"], ["", "Tutti"]];

export default function Centers() {
  const [params, setParams] = useSearchParams();
  const status = params.get("stato") ?? "pending";
  const [q, setQ] = useState("");
  const [ct, setCt] = useState("all");
  const qs = new URLSearchParams({ ...(status && { status }), ...(q && { q }), ...(ct !== "all" && { client_type_id: ct }) }).toString();
  const { data, loading } = useFetch(`/admin/centers?${qs}`);
  const { data: lists } = useFetch("/admin/lists");

  return (
    <div>
      <PageHeader eyebrow="Centri" title="I centri Skin Lovers" subtitle="Iscrizioni da verificare e schede dei centri clienti." />
      <div className="flex gap-6 overflow-x-auto border-b border-warm/40 mb-6">
        {TABS.map(([k, l]) => (
          <button key={l} data-testid={`centers-tab-${k || "all"}`} onClick={() => setParams(k ? { stato: k } : { stato: "" })}
            className={`pb-3 text-[12px] uppercase tracking-[0.16em] whitespace-nowrap border-b-2 transition-colors ${status === k ? "border-gold text-ink" : "border-transparent text-warm-text"}`}>
            {l}
          </button>
        ))}
      </div>
      <div className="flex flex-col sm:flex-row gap-3 mb-6">
        <div className="relative flex-1">
          <Search className="w-4 h-4 absolute left-3 top-3.5 text-warm-text" />
          <TextInput data-testid="centers-search-input" placeholder="Cerca per nome, città, email, P.IVA" value={q} onChange={(e) => setQ(e.target.value)} className="pl-9" />
        </div>
        <Select value={ct} onValueChange={setCt}>
          <SelectTrigger data-testid="centers-type-filter" className="sm:w-64 bg-ivory-deep rounded-xl h-11"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">Tutte le tipologie</SelectItem>
            {(lists?.["client-types"] || []).map((t) => <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>)}
          </SelectContent>
        </Select>
      </div>
      {loading && !data ? <Loader /> : !data?.length ? <EmptyState title="Nessun centro" text="Non ci sono centri con questi filtri." /> : (
        <div className="lux-card divide-y divide-warm/30" data-testid="centers-list">
          {data.map((c) => (
            <Link key={c.id} to={`/admin/centri/${c.id}`} data-testid={`center-row-${c.id}`} className="flex items-center gap-4 px-5 py-4 hover:bg-ivory-deep/60 transition-colors">
              <div className="flex-1 min-w-0 grid sm:grid-cols-[2fr_1fr_1fr_auto] gap-1 sm:gap-6 sm:items-center">
                <div className="min-w-0"><p className="font-serif text-lg truncate">{c.center_name}</p><p className="text-xs text-warm-text truncate">{c.company_name} · {c.email}</p></div>
                <p className="text-sm text-warm-text">{c.city} ({c.province})</p>
                <p className="text-sm">{c.client_type_name || <span className="text-warm-text">—</span>}</p>
                <div className="flex items-center gap-4"><CenterStatusBadge status={c.status} /><span className="text-xs text-warm-text hidden sm:inline">{fmtDate(c.created_at)}</span></div>
              </div>
              <ChevronRight className="w-4 h-4 text-warm shrink-0" />
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
